module.exports = "https://static.energy5.com/_next/static/images/lgElectronics-38c3d12d1457cac94e2a60b061c7de27.png";